import script from "./WorkStationLinkTreeWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkStationLinkTreeWidget.vue?vue&type=script&setup=true&lang=js"

import "./WorkStationLinkTreeWidget.vue?vue&type=style&index=0&id=52e01ee2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52e01ee2"]])

export default __exports__